import { useEffect } from 'react';
import CollectionPage from './CollectionPage';

export default function WireWrappedStones() {
  useEffect(() => { document.title = 'Pencil Wire Wrapped Crystals | SpinWorld.Us'; }, []);
  return (
    <CollectionPage
      category="Jewelry"
      title="Wear the Earth"
      subtitle="Natural crystals, hand wire-wrapped"
      heroImage=""
      heroGradient
      description="Every wire-wrapped pendant features a genuine natural crystal or gemstone point, hand-wrapped in copper wire by skilled artisans. Each stone carries its own unique color, shape, and energy — wearable art from the earth that connects you to nature."
    />
  );
}